export const ENCOUNTER_IDS = {
  mythic: {
    all_dungeons: "all",
    iron_docks: 61195,
    grimrail_depot: 61208,
    lower_karazhan: 61651,
    upper_karazhan: 61652,
    operation_mechagon_junkyard: 62097,
    operation_mechagon_workshop: 62098,
    tazavesh_streets_of_wonder: 62441,
    tazavesh_soleahs_gambit: 62442,
    ruby_life_pools: 62521,
    halls_of_valor: 61477,
    the_nokhud_offensive: 62516,
    shadowmoon_burial_grounds: 61176,
    court_of_stars: 61571,
    temple_of_the_jade_serpent: 10960,
    algethar_academy: 62526,
    the_azure_vault: 62515,
    halls_of_infusion: 62527,
    brackenhide_hollow: 62520,
    uldaman: 62451,
    neltharus: 62519,
    neltharions_lair: 61458,
    freehold: 61754,
    underrot: 61841,
    vortex_pinnacle: 10657,
    galakronds_fall: 12579,
    murozonds_rise: 12580,
    waycrest_manor: 61862,
    ataldazar: 61763,
    darkheart_thicket: 61466,
    black_rook_hold: 61501,
    everbloom: 61279,
    throne_of_the_tides: 10643,
    arakara_city_of_echoes: 12660,
    city_of_threads: 12669,
    grim_batol: 60670,
    mists_of_tirna_scithe: 62290,
    siege_of_boralus: 61822,
    the_dawnbreaker: 12662,
    the_necrotic_wake: 62286,
    the_stonevault: 12652,
    cinderbrew_meadery: 12661,
    darkflame_cleft: 12651,
    // operation_floodgate: 12773, old season 2
    operation_mechagon_workshop: 112098,
    // priory_of_the_sacred_flame: 12649, old season 2
    the_motherlode: 61594,
    the_rookery: 12648,
    theater_of_pain: 62293,
    ara_kara_city_of_echoes: 62660,
    eco_dome_aldani: 12830,
    operation_floodgate: 62773,
    halls_of_atonement: 62287,
    priory_of_the_sacred_flame: 62773,
    tazavesh_soleahs_gambit: 112442,
    tazavesh_streets_of_wonder: 112441,
    the_dawnbreaker: 62662,
  },
  raid: {
    all_bosses: "all",
    vigilant_guardian: 2512,
    dausegne: 2540,
    artificer_xymox_sepulcher: 2553,
    prototype_pantheon: 2544,
    skolex: 2542,
    halondrus: 2529,
    lihuvim: 2539,
    anduin_wrynn: 2546,
    lords_of_dread: 2543,
    rygelon: 2549,
    the_jailer: 2537,
    tarragrue: 2423,
    eye_of_jailer: 2433,
    the_nine: 2429,
    remnant_of_nerzhul: 2432,
    soulrender_dormazain: 2434,
    painsmith_raznal: 2430,
    guardian_of_the_first_ones: 2436,
    fatescribe_rohkalo: 2431,
    kelthuzad: 2422,
    sylvanas_windrunner: 2435,
    shriekwing: 2398,
    huntsman_altimor: 2418,
    hungering_destroyer: 2383,
    sun_kings_salvation: 2402,
    artificer_xymox_nathria: 2405,
    lady_inerva_darkvein: 2406,
    council_of_blood: 2412,
    sludgefist: 2399,
    stone_legion_generals: 2417,
    sire_denathrius: 2407,
    eranog: 2587,
    terros: 2639,
    the_primal_council: 2590,
    sennarth_the_cold_breath: 2592,
    dathea_ascended: 2635,
    kurog_grimtotem: 2605,
    broodkeeper_diurna: 2614,
    raszageth_the_stormeater: 2607,
    kazzara: 2688,
    amalgamation_chamber: 2687,
    forgotten_experiments: 2693,
    zaqali_assault: 2682,
    rashok: 2680,
    zskarn: 2689,
    magmorax: 2683,
    echo_of_neltharion: 2684,
    scalecommander_sarkareth: 2685,
    gnarlroot: 2820,
    igira: 2709,
    volcoross: 2737,
    council_of_dreams: 2728,
    larodar: 2731,
    nymue: 2708,
    smolderon: 2824,
    tindral_sageswift: 2786,
    fyrakk: 2677,
    ulgrax_the_devourer: 2902,
    the_bloodbound_horror: 2917,
    sikran_captain_of_the_sureki: 2898,
    rashanan: 2918,
    broodtwister_ovinax: 2919,
    nexus_princess_kyveza: 2920,
    the_silken_court: 2921,
    queen_ansurek: 2922,
    vexie_and_the_geargrinders: 3009,
    cauldron_of_carnage: 3010,
    rik_reverb: 3011,
    stix_bunkjunker: 3012,
    sprocketmonger_lockenstock: 3013,
    the_one_armed_bandit: 3014,
    mugzee_heads_of_security: 3015,
    chrome_king_gallywix: 3016,
    plexus_sentinel: 3129,
    loomithar: 3131,
    soulbinder_naazindhri: 3130,
    forgeweaver_araz: 3132,
    the_soul_hunters: 3122,
    fractillus: 3133,
    nexus_king_salhadaar: 3134,
    dimensius_the_all_devouring: 3135,
  },
};
